/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */
import { TabPanel, TabView } from "primereact/tabview";
import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Dashboard components
import MDBox from "components/MDBox";

// Dashboard example components

// @mui material components
import Grid from "@mui/material/Grid";

import { getSubModulesByRoleId } from "../../../store";

import Cookies from "universal-cookie";
import Rejections from "./rejection-1";
import AcceptedRejections from "./rejection-2";

const cookies = new Cookies();

const REJSTW = ({ getSubModulesByRoleId, getSubModulesByRoleIdReducer }) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let REJSTW = modulesData.find(
    (moduleId) => moduleId.moduleId == "13c26613-8372-4cb1-9dcf-da1388c0a4b5",
  );

  // let acceptedListModule = modulesData.find(
  //   (moduleId) => moduleId.moduleId == "0bd8495a-86ea-49ed-bc83-efaf40107d4e"
  // );

  return (
    <MDBox pt={0} pb={3}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <TabView>
            <TabPanel header="Rejections">
              <Rejections />
            </TabPanel>
            <TabPanel header="Accepted List">
              <AcceptedRejections />
            </TabPanel>
          </TabView>
        </Grid>
      </Grid>
    </MDBox>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(REJSTW);
